import type { dashboardWidgetRegistry } from '@/components/dashboard/DashboardCanvas';
import { IntegrationMetricRenderer } from './IntegrationMetricRenderer';
import { IntegrationPerformanceRenderer } from './IntegrationPerformanceRenderer';
import type { IntegrationDashboardRuntime } from './widgetRuntime';
import {
  integrationMetricWidgetSchema,
  integrationPerformanceChartWidgetSchema,
  IntegrationDashboardWidgetType,
  type IntegrationDashboardWidget,
} from './widgetModel';

export const integrationDashboardWidgetRegistry: dashboardWidgetRegistry<
  IntegrationDashboardWidget,
  IntegrationDashboardRuntime
> = {
  [IntegrationDashboardWidgetType.Metric]: {
    schema: integrationMetricWidgetSchema,
    component: IntegrationMetricRenderer,
    twoPerMobileRow: true,
  },
  [IntegrationDashboardWidgetType.PerformanceChart]: {
    schema: integrationPerformanceChartWidgetSchema,
    component: IntegrationPerformanceRenderer,
  },
};
